import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { setPolicyName } from './actions';

const nameReducer = handleActions(
  {
    [setPolicyName.toString()]: (_, { payload: name }) => name
  },
  ''
);

export default combineReducers({
  name: nameReducer
});
